module.exports = __webpack_public_path__ + "static/media/dyer_bowman_bennett_small_gibson_paula_pusins_gibbons_valdez_lentz_mosca.d503831f.jpg";